
export default function isEmpty() {
  return function(obj) {
    return Object.keys(obj || {}).length === 0;
  };
}
